"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorBoundary = void 0;
var react_1 = __importDefault(require("react"));
var router_1 = require("next/router");
var LoggerFactory_1 = require("./utils/LoggerFactory");
var PageLoadProvider_1 = require("./PageLoadProvider");
var LOG = LoggerFactory_1.LoggerFactory.create('MetricsErrorBoundary');
var getUrl = function (router) {
    return router.basePath || router.asPath ? "".concat(router.basePath || '').concat(router.asPath || '') : null;
};
var initialState = { error: null, errorUrl: null, stackTrace: null };
/**
 * ErrorBoundary that catches errors and reports page_load errors and provides a
 * recovery mechanism.
 *
 * This ErrorBoundary is for wrapping the Next.js Component with, it catches
 * errors and prevents the entire React component tree from remounting and loosing
 * state. This causes all the server properties on the App component to be lost.
 * See https://reactjs.org/docs/error-boundaries.html#new-behavior-for-uncaught-errors
 * for additional details on error handling.
 */
var ErrorBoundary = /** @class */ (function (_super) {
    __extends(ErrorBoundary, _super);
    function ErrorBoundary(props, context) {
        var _this = _super.call(this, props, context) || this;
        _this.reset = function () {
            // To reset just reset the error, content will begin rendering again once
            // a different url is navigated to (this is to ensure an error loop does
            // not occur)
            _this.setState({ error: null });
        };
        _this.state = initialState;
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function (error) {
        return { error: error };
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, info) {
        var stackTrace;
        try {
            stackTrace = info.componentStack
                .split('\n')
                .filter(function (p) { return p.replace(' ', '') !== ''; })[0]
                .trim();
        }
        catch (e) {
            stackTrace = 'Not Available';
            LOG.debug('Failed trying to get the error stack trace', e);
        }
        var _a = this.context, url = _a.url, trackPageLoad = _a.trackPageLoad;
        var data = this.props.sliData || {};
        // Should we track the error or here or is the consumer asking for delegation?
        if (!this.props.delegateTracking) {
            trackPageLoad(url, 'error', __assign({ error_message: error.message, type: 'unhandled_error', httpLogPageLoadId: this.props.httpLogPageLoadId, stackTrace: stackTrace }, data));
        }
        else {
            // Consumer wants the error and track it on its own
            this.setState({ errorUrl: getUrl(this.props.router), stackTrace: stackTrace });
        }
        LOG.error("Error on ".concat(url, "."), error);
    };
    ErrorBoundary.prototype.componentDidUpdate = function () {
        if (this.state.error) {
            if (!this.state.errorUrl) {
                // If there is an error, capture the current url so we can wait to
                // fully reset until after next loads the previous url.
                // eslint-disable-next-line react/no-did-update-set-state
                this.setState({ errorUrl: getUrl(this.props.router) });
            }
        }
        else if (this.state.errorUrl && getUrl(this.props.router) !== this.state.errorUrl) {
            // If  there is no longer an error, once the route changes away from
            // the error url reset the state entirely to render content again.
            // eslint-disable-next-line react/no-did-update-set-state
            this.setState(initialState);
        }
    };
    ErrorBoundary.prototype.render = function () {
        if (this.state.errorUrl || this.state.error) {
            var ErrorComponent = this.props.errorComponent;
            return (react_1.default.createElement(ErrorComponent, { reset: this.reset, error: this.state.error, url: this.state.errorUrl, sliData: __assign(__assign({}, this.props.sliData), { httpLogPageLoadId: this.props.httpLogPageLoadId, stackTrace: this.state.stackTrace }) }));
        }
        return this.props.children;
    };
    ErrorBoundary.contextType = PageLoadProvider_1.PageLoadContext;
    return ErrorBoundary;
}(react_1.default.Component));
exports.ErrorBoundary = ErrorBoundary;
exports.default = (0, router_1.withRouter)(ErrorBoundary);
